import { useCallback, useState } from 'react';

const STORAGE_KEY = 'dnk-recent-clients';
const MAX_RECENT = 3;

const read = (): string[] => {
  try {
    const raw = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '[]');
    return Array.isArray(raw) ? raw.filter((id): id is string => typeof id === 'string') : [];
  } catch {
    return [];
  }
};

export function useRecentClients() {
  const [recentIds, setRecentIds] = useState<string[]>(read);

  const remember = useCallback((clientId: string) => {
    const next = [clientId, ...read().filter((id) => id !== clientId)].slice(0, MAX_RECENT);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
      // storage unavailable
    }
    setRecentIds(next);
  }, []);

  return { recentIds, remember, maxRecent: MAX_RECENT };
}
